import React, { useEffect, useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTrash2, FiMessageSquare } = FiIcons;

const NotesSidebar = ({ markers, updateMarkerText, deleteMarker, selectedMarkerId, setSelectedMarkerId }) => {
  const selectedRef = useRef(null);

  useEffect(() => {
    if (selectedMarkerId && selectedRef.current) {
      selectedRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      // Focus the textarea
      const textarea = selectedRef.current.querySelector('textarea');
      if (textarea) textarea.focus();
    }
  }, [selectedMarkerId]);

  if (markers.length === 0) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center text-gray-400 p-6 text-center">
        <SafeIcon icon={FiMessageSquare} className="text-4xl mb-3 opacity-50" />
        <p className="text-sm">Klik op de afbeelding om je eerste notitie toe te voegen.</p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
      <h3 className="font-semibold text-gray-700 mb-4 px-1">Notities ({markers.length})</h3>
      <div className="space-y-3">
        {markers.map((marker) => {
          const isSelected = selectedMarkerId === marker.id;
          return (
            <div 
              key={marker.id}
              ref={isSelected ? selectedRef : null}
              className={`bg-white p-3 rounded-xl border transition-all ${
                isSelected ? 'border-blue-500 shadow-md ring-1 ring-blue-500' : 'border-gray-200 hover:border-blue-300 shadow-sm'
              }`}
              onClick={() => setSelectedMarkerId(marker.id)}
            >
              <div className="flex items-start gap-3">
                <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center font-bold text-sm text-white ${
                  isSelected ? 'bg-blue-600' : 'bg-gray-400'
                }`}>
                  {marker.number}
                </div>
                <div className="flex-1">
                  <textarea
                    value={marker.text}
                    onChange={(e) => updateMarkerText(marker.id, e.target.value)}
                    placeholder="Voeg een opmerking toe..."
                    className="w-full text-sm text-gray-700 resize-none outline-none bg-transparent min-h-[60px]"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteMarker(marker.id);
                  }}
                  className="text-gray-400 hover:text-red-500 p-1 transition-colors"
                  title="Verwijder notitie"
                >
                  <SafeIcon icon={FiTrash2} />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NotesSidebar;